// Church logo: official Iglesia Nueva Cancion artwork (red cross + arched wordmark).
import logoUrl from "@/assets/logo.png";

export function Logo({ size = 40, className = "", showRing = true }) {
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden rounded-2xl bg-white ${showRing ? "shadow-sm ring-1 ring-black/5" : ""} ${className}`}
      style={{ width: size, height: size }}
      aria-label="Iglesia Nueva Cancion"
      data-testid="church-logo"
    >
      <img
        src={logoUrl}
        alt="Iglesia Nueva Cancion"
        width={size}
        height={size}
        draggable={false}
        className="h-full w-full object-contain select-none"
      />
    </span>
  );
}

export function LogoMark({ size = 28 }) {
  return (
    <img
      src={logoUrl}
      alt="Iglesia Nueva Cancion"
      width={size}
      height={size}
      draggable={false}
      className="object-contain"
      style={{ width: size, height: size }}
    />
  );
}

// Larger badge variant useful on register/login hero where we want the full
// artwork to breathe (no rounded white card so the white background blends).
export function LogoArtwork({ size = 220, className = "" }) {
  return (
    <img
      src={logoUrl}
      alt="Iglesia Nueva Cancion"
      width={size}
      height={size}
      draggable={false}
      className={`object-contain select-none ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
